// extracted by mini-css-extract-plugin
module.exports = {"insightIconsWrapper":"isHRPGG4","disabled":"_BhLWM0L","styledImg":"HLZmiX8t"};